export type ProfilePasswordRuleId = 'len' | 'upper' | 'lower' | 'digit' | 'special';

export interface ProfilePasswordRuleCheck {
  id: ProfilePasswordRuleId;
  label: string;
  ok: boolean;
}

/** Reglas alineadas con backend `profilePasswordPolicy.ts` */
export function getProfilePasswordChecks(password: string): ProfilePasswordRuleCheck[] {
  const p = password;
  return [
    { id: 'len', label: 'Mínimo 8 caracteres.', ok: p.length >= 8 },
    { id: 'upper', label: 'Al menos 1 letra mayúscula.', ok: /[A-Z]/.test(p) },
    { id: 'lower', label: 'Al menos 1 letra minúscula.', ok: /[a-z]/.test(p) },
    { id: 'digit', label: 'Al menos 1 número.', ok: /\d/.test(p) },
    {
      id: 'special',
      label: 'Al menos 1 carácter especial.',
      ok: /[^A-Za-z0-9]/.test(p)
    }
  ];
}

export function profileNewPasswordMeetsPolicy(password: string): boolean {
  if (!password.trim()) return true;
  return getProfilePasswordChecks(password).every((c) => c.ok);
}
